import axios from 'axios'
import axiosRetry from 'axios-retry'

// retry setup (as before)
axiosRetry(axios, {
  retries: 3,
  retryDelay: axiosRetry.exponentialDelay,
})

// // interceptor to ensure a trailing slash
// axios.interceptors.request.use(config => {
//   if (config.url) {
//     // split off any querystring
//     const [path, query] = config.url.split('?')
//     // only add slash when not already present
//     const normalizedPath = path.endsWith('/') ? path : path + '/'
//     config.url = query ? `${normalizedPath}?${query}` : normalizedPath
//   }
//   return config
// }, error => Promise.reject(error))

export default axios
